<template>
    <div>
        <el-date-picker
                    @change="query"
                    size="mini"
                    style="width:150px;z-index:999999;position:absolute;left:30px;top:105px"
            
                    v-model="selDate"
                    type="date"
                    placeholder="选择日期">
                    </el-date-picker>
          <el-table
          v-loading="isLoading"
            :data="tableData"
            show-summary
            :height="bodyHeight"
            style="width: 100%">
            <el-table-column
            prop="Name">
            </el-table-column>
            <el-table-column
            prop="Phone"
            label="手机号">
            </el-table-column>
            <el-table-column
            prop="WaitNum"
            sortable
            label="待处理（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type=""  >  {{ scope.row.WaitNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="WaitMoney"
            sortable
            label="待处理（金额）">
                <template slot-scope="scope">
                    <el-tag  size="small" type=""  >  {{ scope.row.WaitMoney }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="OkNum"
            sortable
            label="完成（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="success" >  {{ scope.row.OkNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="OkMoney"
            sortable
            label="完成（金额）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="success" >  {{ scope.row.OkMoney }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="FailNum"
            sortable
            label="失败（单数）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="danger" >  {{ scope.row.FailNum }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="FailMoney"
            sortable
            label="失败（金额）">
                <template slot-scope="scope">
                      <el-tag  size="small" type="danger"  >  {{ scope.row.FailMoney }} </el-tag>
                </template>
            </el-table-column>
            <el-table-column
            prop="LastTime"
            label="最后操作时间">
            </el-table-column>
            <el-table-column
            label="在线状态">
                <template slot-scope="scope">
                    <el-switch
                    @change="changeIsOnLine(scope.row)"
                    v-model="scope.row.IsOnLine"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { swipeBillGetKanBan,swipeBillSetIsOnLine} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {

    data(){
        return {
            bodyHeight:0,
            isLoading:false,
            tableData:[],
            selDate:"",
            timer:{},
        }
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.selDate=new Date();
    },
    mounted(){
       this.query();
       this.timer= setInterval(() => {
           this.query();
       }, 5000);
    },
    methods: {
        changeIsOnLine(scope){
            swipeBillSetIsOnLine({isOnLine:scope.IsOnLine,outsiderId:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
            })
        },
        query(){
            this.isLoading=true;
            var date= formatDate(new Date(this.selDate),"yyyy-MM-dd")
            swipeBillGetKanBan({date:date},(res)=>{
                this.tableData=res.Result;
                this.isLoading=false;
            })
        },
    }
}
</script>